// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"f1428eed","757":"9a02b172","834":"37d3a091"}[chunkId] + ".chunk.css";
};